"use strict";
import CarrierService from "../services/carrier_service";
var Carriers = {
  nameAndInfoForId: function(carrierId) {
    var carrier = CarrierService.getCarrierOrUnknown(carrierId);
    var output = carrier.name;
    if (carrier.mc_number) {
      output += " - MC# ";
      output += carrier.mc_number;
    }
    if (carrier.ein) {
      output += " - EIN ";
      output += carrier.ein;
    }
    if (carrier.scac) {
      output += " - SCAC ";
      output += carrier.scac;
    }
    return output;
  }
};
export default Carriers;
